import { createRestSlice } from "./restSlice";

export enum EvaluatorType {
  JUDGE = "judge",
  EXTRACTION = "extraction",
  SCRIPT = "script",
  DETERMINISTIC = "deterministic",
}

export enum TargetFormat {
  EVENTS = "events",
  TRANSCRIPT = "transcript",
  TRACE = "trace",
}

export type Evaluator = {
  id: string;
  organizationId: string;
  title: string;
  evalType: EvaluatorType;
  targetFormat: TargetFormat;
  apiProvider?: string;
  model?: string;
  systemPrompt?: string | null;
  responseSchema?: Record<string, unknown> | null;
  successCriteria?: Record<string, unknown> | null;
  code?: string | null;
  organizationSecretName?: string | null;
  // Predicate that gates whether this eval runs against a session.
  precondition?: Record<string, unknown> | null;
  // Deterministic-eval assertion (predicate over the SessionView).
  assertion?: Record<string, unknown> | null;
  createdAt?: string;
  updatedAt?: string;
};

export type AgentJudge = Evaluator & {
  apiProvider: string;
  model: string;
  evalType: EvaluatorType.JUDGE;
  systemPrompt: string;
  responseSchema: Record<string, unknown>;
  successCriteria: Record<string, unknown>;
};

export type AgentExtractor = Evaluator & {
  apiProvider: string;
  model: string;
  evalType: EvaluatorType.EXTRACTION;
  systemPrompt: string;
  responseSchema?: Record<string, unknown>;
};

export type AgentScript = Evaluator & {
  evalType: EvaluatorType.SCRIPT;
  code: string;
};

const evaluatorSlice = createRestSlice<Evaluator>("evaluators", "/v1/evaluators");

export const evaluatorReducer = evaluatorSlice.reducer;
export const evaluatorActions = evaluatorSlice.actions;
